import React, { Component } from "react";
import {
    Col,
} from "react-bootstrap";
import { hasPermission } from 'helper/hasPermission';

export default class ConfigurationEmails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            administrative_email: {
                id: '',
                value: ''
            },
            technical_email: {
                id: '',
                value: ''
            },
            administrative_email_array: [],
            technical_email_array: [],
            administrative_email_valid: true,
            technical_email_valid: true,
        };
    }

    handleInput = e => {
        const { name, value } = e.target;
        this.setState({
            [name]: {
                ...this.state[name],
                value: value,
            },
        })
    }

    handleBlurEmailValidation = (e) => {
        const { name } = e.target;
        if (this.state[name].value) {
            let splittedArray;
            if (Array.isArray(this.state[name].value)) {
                let stringified = this.state[name].value.join();
                splittedArray = stringified.replace(/\s+/g, '').split(',');
            }
            else {
                splittedArray = this.state[name].value.replace(/\s+/g, '').split(',');
            }
            this.setState({
                [name + '_array']: splittedArray
            }, () => {
                if (this.state[name + '_array'].length > 0) {
                    this.state[name + '_array'].forEach(data => {
                        // if (/^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/.test(data)) {
                        if (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(data)) {
                            this.setState({
                                [name + '_valid']: true
                            })
                        }
                        else {
                            this.setState({
                                [name + '_valid']: false
                            })
                        }
                    })
                }
            })
        }
        else if (!this.state[name].value) {
            this.setState({
                [name + '_valid']: true
            })
        }
    }
    componentDidMount() {
        this.setState({
            ...this.state,
            administrative_email: this.props.admin_email[0],
            technical_email: this.props.tech_email[0]
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.admin_email !== prevProps.admin_email) {
            this.setState({
                ...this.state,
                administrative_email: this.props.admin_email[0],
                technical_email: this.props.tech_email[0]
            })
        }
    }
    render() {
        return (
            <div>
                <Col md={12} className="mt-md">
                    <div className="apiField larger">
                        General Settings
                    </div>

                    <div className="row">
                        <div className="col-md-3 mt-lg text-right col-md-offset-2 bordered">
                            <div className="settingsInfo">Administrative Email:</div>
                        </div>

                        <div className="col-md-5 mt-lg">
                            <input type="text" onBlur={this.handleBlurEmailValidation} name='administrative_email' className='form-control' onChange={this.handleInput} placeholder='Enter comma seperated list' value={this.state.administrative_email.value || ''}
                                disabled={hasPermission('edit-configuration-settings-emails') ? false : true}
                            />

                            {/* <span className="customMsg">
                                {this.validator.message(
                                    "Administrative Email",
                                    this.state.administrative_email.value,
                                    "required"
                                )}
                            </span> */}
                            {
                                !this.state.administrative_email_valid &&
                                <span style={{ color: 'red' }}>Please enter valid email(s)</span>
                            }

                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-3 mt-lg text-right col-md-offset-2 bordered">
                            <div className="settingsInfo">Technical Email:</div>
                        </div>
                        <div className="col-md-5 mt-lg">
                            <input type="text" name='technical_email' className='form-control' onBlur={this.handleBlurEmailValidation} onChange={this.handleInput} placeholder='Enter comma seperated list' value={this.state.technical_email.value || ''}
                                disabled={hasPermission('edit-configuration-settings-emails') ? false : true} />
                            <span className="customMsg">
                                {/* {this.validator.message(
                                    "Technical Email",
                                    this.state.technical_email.value,
                                    "required"
                                )} */}
                            </span>

                            {
                                !this.state.technical_email_valid &&
                                <span style={{ color: 'red' }}>Please enter valid email(s)</span>
                            }

                        </div>
                    </div>
                </Col>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Admin/Settings/ConfigurationEmails.jsx